import {
  CountryID,
  CountryCode,
  CurrencyCode,
  LanguageId,
  LanguageCode,
  CurrencyCodeId,
  CountryPhoneCode,
  CountryNameAlias,
  CountryEnName,
} from "../common/enums";

interface ConfigItem {
  name: CountryNameAlias;
  enName: CountryEnName;
  value: CountryID;
  countryId: CountryID;
  countryCode: CountryCode;
  currencyId: CurrencyCodeId;
  currencyCode: CurrencyCode;
  languageId: LanguageId;
  languageCode: LanguageCode;
  phoneCode: CountryPhoneCode;
  timeZone: number;
  dateFormat: string;
}

type KeyNameType = keyof ConfigItem;

type KeyNameArrType = Array<KeyNameType>;

interface CountryParams {
  keyName?: KeyNameType;
  valueKeys: KeyNameType | KeyNameArrType;
}

export const AllCountryList: Array<ConfigItem> = [
  {
    name: CountryNameAlias.ID,
    enName: CountryEnName.ID,
    value: CountryID.ID,
    countryId: CountryID.ID,
    countryCode: CountryCode.ID,
    currencyId: CurrencyCodeId[CurrencyCode.ID],
    currencyCode: CurrencyCode.ID,
    languageId: LanguageId.in,
    languageCode: LanguageCode.in,
    phoneCode: CountryPhoneCode.ID,
    timeZone: 7,
    dateFormat: "DD/MM/YYYY",
  },
  {
    name: CountryNameAlias.MY,
    enName: CountryEnName.MY,
    value: CountryID.MY,
    countryId: CountryID.MY,
    countryCode: CountryCode.MY,
    currencyId: CurrencyCodeId[CurrencyCode.MY],
    currencyCode: CurrencyCode.MY,
    languageId: LanguageId.ms,
    languageCode: LanguageCode.ms,
    phoneCode: CountryPhoneCode.MY,
    timeZone: 8,
    dateFormat: "DD/MM/YYYY",
  },
  {
    name: CountryNameAlias.PH,
    enName: CountryEnName.PH,
    value: CountryID.PH,
    countryId: CountryID.PH,
    currencyCode: CurrencyCode.PH,
    currencyId: CurrencyCodeId[CurrencyCode.PH],
    countryCode: CountryCode.PH,
    languageId: LanguageId.en,
    languageCode: LanguageCode.en,
    phoneCode: CountryPhoneCode.PH,
    timeZone: 8,
    dateFormat: "MM/DD/YYYY",
  },
  {
    name: CountryNameAlias.VN,
    enName: CountryEnName.VN,
    value: CountryID.VN,
    countryId: CountryID.VN,
    countryCode: CountryCode.VN,
    currencyId: CurrencyCodeId[CurrencyCode.VN],
    currencyCode: CurrencyCode.VN,
    languageId: LanguageId.vi,
    languageCode: LanguageCode.vi,
    phoneCode: CountryPhoneCode.VN,
    timeZone: 7,
    dateFormat: "DD/MM/YYYY",
  },
  {
    name: CountryNameAlias.CHN,
    enName: CountryEnName.CHN,
    value: CountryID.CHN,
    countryId: CountryID.CHN,
    countryCode: CountryCode.CHN,
    currencyId: CurrencyCodeId[CurrencyCode.CHN],
    currencyCode: CurrencyCode.CHN,
    languageId: LanguageId.zh,
    languageCode: LanguageCode.zh,
    phoneCode: CountryPhoneCode.CHN,
    timeZone: 8,
    dateFormat: "YYYY/MM/DD",
  },
  {
    name: CountryNameAlias.DE,
    enName: CountryEnName.DE,
    value: CountryID.DE,
    countryId: CountryID.DE,
    countryCode: CountryCode.DE,
    currencyId: CurrencyCodeId[CurrencyCode.DE],
    currencyCode: CurrencyCode.DE,
    languageId: LanguageId.de,
    languageCode: LanguageCode.de,
    phoneCode: CountryPhoneCode.DE,
    timeZone: 1,
    dateFormat: "DD/MM/YYYY",
  },
  {
    name: CountryNameAlias.ES,
    enName: CountryEnName.ES,
    value: CountryID.ES,
    countryId: CountryID.ES,
    countryCode: CountryCode.ES,
    currencyId: CurrencyCodeId[CurrencyCode.ES],
    currencyCode: CurrencyCode.ES,
    languageId: LanguageId.es,
    languageCode: LanguageCode.es,
    phoneCode: CountryPhoneCode.ES,
    timeZone: 1,
    dateFormat: "DD/MM/YYYY",
  },
];

/**
 * 国家字段表，键为 CountryID
 */
export const AllCountryMap = AllCountryList.reduce((result, item) => {
  result[item.countryId] = item;
  return result;
}, {} as Record<CountryID, ConfigItem>);

// import {
//   CountryID,
//   CountryCode,
//   CurrencyCode,
//   LanguageId,
//   LanguageCode,
//   CurrencyCodeId,
//   CountryPhoneCode,
//   CountryNameAlias,
//   CountryEnName,
// } from "../common/enums";

type KeyNameValueType =
  | CountryID
  | CountryCode
  | CountryPhoneCode
  | CountryNameAlias
  | CountryEnName;

/*
 * 获取所有国家某一个字段的枚举遍历
 */
export const getAllCountryConfig = <K extends KeyNameValueType = CountryID, V = CountryNameAlias>(
  { keyName = "countryId", valueKeys = "name" }: CountryParams = {
    keyName: "countryId", // 默认key值 为国家ID
    valueKeys: "name",
  }
): {
  [key in K]?: V;
} => {
  const returnObj = {};

  AllCountryList.map((i) => {
    const defaultKeyValue = i[keyName];

    if (Array.isArray(valueKeys)) {
      const keyItem = {};
      valueKeys.length &&
        valueKeys.map((keyNameItem) => {
          Object.assign(keyItem, { [keyNameItem]: i[keyNameItem] || `${keyNameItem} not exist` });
        });

      Object.assign(returnObj, { [defaultKeyValue]: keyItem });
    } else {
      Object.assign(returnObj, {
        [defaultKeyValue]: i[valueKeys] || `${valueKeys} not exist`,
      });
    }
  });

  return returnObj;
};
